import { Storybook } from "@tento-ui/ui/storybook";
import { TextCell } from "./text-cell.ts";
import "./text-cell.ts";

const TEST_MARKDOWN = `
# h1 Heading
## h2 Heading

This is a paragraph with some **bold** and *italic* text.

- bullet point 1
- bullet point 2

> This is a blockquote with some longer text.

Some inline \`code\` here.
`;

/** The storybook page for the text cell, for a component gallery. */
export class TextCellStoryBook extends Storybook.Default {
  title(): string {
    return "TextCell";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Narrow container (48px) - horizontal scroll",
        render: () => {
          const $cell = TextCell.make();
          $cell.assignStyles({
            width: "100%",
            maxWidth: "200px",
            height: "200px",
          });
          $cell.bind({
            markdown: TEST_MARKDOWN,
          });
          return $cell;
        },
      },
      {
        title: "Empty with placeholder",
        render: () => {
          const $cell = TextCell.make();
          $cell.assignStyles({
            width: "100%",
            maxWidth: "200px",
            height: "100px",
          });
          $cell.bind({
            placeholder: "Type something here...",
          });
          return $cell;
        },
      },
      {
        title: "Read-only mode",
        render: () => {
          const $cell = TextCell.make();
          $cell.assignStyles({
            width: "100%",
            maxWidth: "200px",
            height: "100px",
          });
          $cell.bind({
            markdown: "This text is **read-only**.",
            editable: false,
          });
          return $cell;
        },
      },
    ];
  }
}
